﻿export class MessageBarService {

    public $rootScope: angular.IRootScopeService;
   
    static $inject = ["$rootScope"];

    public constructor($rootScope: angular.IRootScopeService) {
        this.$rootScope = $rootScope;
    }

    public broadcast(messageType: MessageType, message: string) {
        this.$rootScope.$broadcast("message", { messageType, message });
    }

    public listen(callback) {
        this.$rootScope.$on("message", callback);
    }


}

export enum MessageType {
    Danger,
    Info,
    Warning
}

export interface IMessageBarMessage {
    message: string;
    messageType: MessageType;
}